import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG } from './constants';
const lines = ['Another golfer.', 'Another lesson.', 'Another drill to find.', 'Another practice to create.', 'Another session to prepare.'];
export function FinalCTA() {
  return <section className="bg-golf-green px-4 py-4 text-white" data-id="element-43" data-mp="83m5dk1n16u8">
      <div className="mx-auto max-w-3xl text-center" data-id="element-44" data-mp="m4f1g97l89zg">
        <h2 className="mb-1 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-45" data-mp="m33wi62eow6r">
          One Last Opportunity
        </h2>
        <div className="mb-1.5 space-y-0.5 text-[13px] font-medium leading-snug text-white/80 sm:text-base" data-id="element-46" data-mp="vtgi81lyiveh">
          {lines.map(line => <p key={line} data-id="element-47" data-mp="qy189kr2ljnc">{line}</p>)}
          <p className="font-semibold text-white" data-id="element-48" data-mp="14whkfr7pc2cv">You can keep doing everything from scratch...</p>
          <p className="font-bold text-golf-lime" data-id="element-49" data-mp="zxek2k2o2kb8">Or open your system and start coaching.</p>
        </div>

        <a href={CHECKOUT_URL} className="mb-2 block" aria-label="Buy GOLF COACH PRO™" data-id="element-50" data-mp="2c5y8xkq9sdcb">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[220px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-51" data-mp="2h4sqykgexxvd" />
        </a>

        <p className="font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-white sm:text-4xl" data-id="element-52" data-mp="2qzkpprlqeqrq">
          GOLF COACH PRO™
        </p>
        <p className="mb-1 font-head text-[12px] font-semibold uppercase text-golf-lime sm:text-base" data-id="element-53" data-mp="301arnrd8p83r">
          Complete 6-in-1 Ready-to-Use Golf Coaching System + 5 Premium Bonuses
        </p>
        <p className="text-[13px] font-medium text-white/75" data-id="element-54" data-mp="39rdl1so9wo2m">
          Regular Price: <span className="line-through" data-id="element-55" data-mp="3es1gqrng5t36">{PRICE_FULL}</span>
        </p>
        <p className="mb-2 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-golf-gold sm:text-4xl" data-id="element-56" data-mp="3it38yoiy54vn">
          TODAY ONLY: {PRICE_TODAY}
        </p>

        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-1.5 max-w-md" data-id="element-57" data-mp="1jm8x84v6oh0h">
          🚀 YES! I WANT GOLF COACH PRO™
        </CTAButton>

        <p className="text-[11px] font-semibold text-white/85 sm:text-sm" data-id="element-58" data-mp="1sh6s3hhw63ug">
          Immediate Access • Digital Delivery
        </p>
        <p className="text-[11px] font-semibold text-white/85 sm:text-sm" data-id="element-59" data-mp="1np597cq7xevg">
          ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews 🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}